<template>
	<b-form-datepicker
		:disabled="disabled"
		required
		size="sm"
		class="mb-1"
		locale="es"
		v-model="modelDate"
	/>
</template>

<script>
import moment from "moment";
export default {
	props: {
		disabled: Boolean,
		value: String,
	},
	computed: {
        time(){
            let aux = moment(this.value);
            return aux.isValid() ? aux.format("HH:mm:00") : "00:00:00";
        },
		modelDate: {
			get() {
				let aux = moment(this.value);
				return aux.isValid() ? aux.format("YYYY-MM-DD") : "";
			},
			set(v) {
				this.$emit("input", `${v} ${this.time}`);
			}
		}
	}
};
</script>
